module.exports = __webpack_public_path__ + "static/media/140316_FRUITICA_MIXCAFFE_STRONG_3in1.56f06b63.jpg";